
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { AlertCircle, Settings, Clock, CheckCircle } from 'lucide-react';

interface MaintenanceStatsProps {
  maintenancesEnRetard: number;
  maintenancesEnCours: number;
  maintenancesEnAttente: number;
  maintenancesTerminees: number;
}

const MaintenanceStats = ({ 
  maintenancesEnRetard, 
  maintenancesEnCours, 
  maintenancesEnAttente, 
  maintenancesTerminees 
}: MaintenanceStatsProps) => {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 lg:gap-6">
      <Card>
        <CardContent className="p-4 lg:p-6">
          <div className="flex items-center gap-2 lg:gap-3">
            <div className="p-1.5 lg:p-2 bg-red-100 rounded-lg">
              <AlertCircle className="h-4 w-4 lg:h-5 lg:w-5 text-red-600" />
            </div>
            <div>
              <p className="text-xs lg:text-sm text-muted-foreground">En retard</p>
              <p className="text-lg lg:text-2xl font-bold text-red-600">{maintenancesEnRetard}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4 lg:p-6">
          <div className="flex items-center gap-2 lg:gap-3">
            <div className="p-1.5 lg:p-2 bg-yellow-100 rounded-lg">
              <Settings className="h-4 w-4 lg:h-5 lg:w-5 text-yellow-600" />
            </div>
            <div>
              <p className="text-xs lg:text-sm text-muted-foreground">En cours</p>
              <p className="text-lg lg:text-2xl font-bold text-yellow-600">{maintenancesEnCours}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4 lg:p-6">
          <div className="flex items-center gap-2 lg:gap-3">
            <div className="p-1.5 lg:p-2 bg-green-100 rounded-lg">
              <Clock className="h-4 w-4 lg:h-5 lg:w-5 text-green-600" />
            </div>
            <div>
              <p className="text-xs lg:text-sm text-muted-foreground">En attente</p>
              <p className="text-lg lg:text-2xl font-bold text-green-600">{maintenancesEnAttente}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4 lg:p-6">
          <div className="flex items-center gap-2 lg:gap-3">
            <div className="p-1.5 lg:p-2 bg-blue-100 rounded-lg">
              <CheckCircle className="h-4 w-4 lg:h-5 lg:w-5 text-blue-600" />
            </div>
            <div>
              <p className="text-xs lg:text-sm text-muted-foreground">Terminées</p>
              <p className="text-lg lg:text-2xl font-bold text-blue-600">{maintenancesTerminees}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default MaintenanceStats;
